import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'worker_2'

export const dataPointDefinition = {
  retracedId: 'worker_2',
  name: 'Worker',
  description:
    "Workers are persons working on/with the facility's product or directly involved in the operations of the facility. They are non-supervisory, which means no one reports to them. Facilities include those involved in production of goods, and also those involved in operations related to the product, e.g",
  meta: {
    slcpMeta: {
      key: 'wi-gri-27',
      number: 'WI-GRI-20',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-gri-27', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36740,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
